import React from 'react';

import './style.css';
import '../../../grid.css';


const MosaicLegal = () => (
    <div className="row">
        <h1 className="section">Financin</h1>
        <p className="row">
            Payment terms may vary by lender based on many factors, including but not limited to, system sizes, system prices, and credit histories.  Financing options are subject to credit approvals by a 3rd party lenders not affiliated with Solvana. Solvana is not a lender and does not guarantee or make any representations concerning the viability, availability, rates, payments, or terms of any loans, leases, or purchase programs quoted by our financial associates, which are independently owned and operated companies. All loan or lease terms are determined and subject to approval by 3rd party lenders. Solvana offers loans for PV solar-generating systems, including energy storage systems, when installed in conjunction with PV solar-generating systems. Payments on residential PV solar loans assume that borrowers apply the full amounts of their Investment Tax Credits to loans by the end of the 18th month from the beginning of the loan terms, at which point in time, loans re-amortize. Autopay avoids the hassle of writing checks and may prevent mail and bank handling delays. Failure to enroll in Autopay results in a 0.25% increased interest rate. All dollar amounts and dates are estimates. Loan Closing Certificates provided by lenders contain final loan documents.


        </p>
    </div>
);

export default MosaicLegal;



// WEBPACK FOOTER //
// ./src/containers/Legal/MosaicLegal/index.js